export interface RegistriaOrderInformation {
  amount: string;
  orderDate: string;
  orderNumber: string;
  sessionId: string;
}
